import React from "react";
import dayjs from "dayjs";

import file from "../../../images/file.png";

import { MessageType } from "./Message";

function DocumentMessage(props) {
  const showMessageTime = () => {
    return props.message.type !== MessageType.info;
  };

  const messageTimeClassName = () => {
    switch (props.message.type) {
      case MessageType.sent:
        return "s360-message-time-sent";
      case MessageType.received:
        return "s360-message-time-received";
      default:
        return "";
    }
  };

  const messageBoxClassName = () => {
    switch (props.message.type) {
      case MessageType.sent:
        return "s360-message-box-sent";
      case MessageType.received:
        return "s360-message-box-received";
      default:
        return "";
    }
  };

  const messageContainerClassName = () => {
    switch (props.message.type) {
      case MessageType.sent:
        return "s360-message-cotainer-sent";
      case MessageType.received:
        return "s360-message-cotainer-received";
      default:
        return "";
    }
  };

  const messageBoxStyle = () => {
    let config = props.config;
    switch (props.message.type) {
      case MessageType.sent:
        return {
          height: "105px",
          background: "#FFFFFF",
          ...config?.customDesign?.documentMessageBoxReceiver
        };
      case MessageType.received:
        return {
          height: "105px",
          background: "#FFFFFF",
          ...config?.customDesign?.documentMessageBoxSender
        };
      default:
        return {};
    }
  };

  const messageTimeStyle = () => {
    let config = props.config;
    switch (props.message.type) {
      case MessageType.received:
      case MessageType.sent:
      case MessageType.info:
        return config?.customDesign?.documentMessageTime;
      default:
        return {};
    }
  };

  return (
    <div className={messageContainerClassName()}>
      <div className={messageBoxClassName()} style={messageBoxStyle()}>
        <a
          target="_blank"
          href={props.message.message.text}
          download
          rel="noreferrer"
        >
          <img
            width="100"
            height="100"
            title={props.message.message.text}
            src={file}
            alt="text"
          ></img>
        </a>
      </div>
      <div style={{ display: "flex", alignItems: "center", marginRight: 7 }}>
        {showMessageTime() && (
          <div
            className={messageTimeClassName()}
            style={messageTimeStyle()}
          >
            {dayjs
              .unix(
                Math.trunc(props.message.message.sentTimestamp / 1000)
              )
              .format("DD MMM h:mm a")}
          </div>
        )}
        {/* <Retry {...props} /> */}
      </div>
    </div>
  );
}

export default DocumentMessage;
